/** Current tax year based on local time */
export const CURRENT_TAX_YEAR = new Date().getFullYear();
